import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function DeleteIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10.8912 6.04546H24.7931C27.6497 6.04546 29.9655 8.38579 29.9655 11.2727V21.7273C29.9655 24.6142 27.6497 26.9545 24.7931 26.9545H10.8912C8.99854 26.9544 7.25655 25.9098 6.35022 24.2306L3.52963 19.0033C2.68753 17.4431 2.68753 15.5569 3.52963 13.9966L6.35022 8.76936C7.25655 7.09014 8.99854 6.04556 10.8912 6.04546Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.5738 12.0118C14.1698 11.6035 13.5148 11.6035 13.1108 12.0118C12.7068 12.4201 12.7068 13.082 13.1108 13.4903L20.4257 20.8828C20.8297 21.2911 21.4847 21.2911 21.8887 20.8828C22.2927 20.4745 22.2927 19.8126 21.8887 19.4043L14.5738 12.0118Z"
        fill="currentColor"
      />
      <path
        d="M14.5738 20.882C14.1698 21.2903 13.5148 21.2903 13.1108 20.882C12.7068 20.4738 12.7068 19.8118 13.1108 19.4035L20.4257 12.0111C20.8297 11.6028 21.4847 11.6028 21.8887 12.0111C22.2927 12.4193 22.2927 13.0813 21.8887 13.4895L14.5738 20.882Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
